import React from 'react'
import { useTranslation } from 'react-i18next'

export default function Contact(){
  const { t } = useTranslation()
  const [toast, setToast] = React.useState('')
  React.useEffect(()=>{
    if(!toast) return
    const t=setTimeout(()=>setToast(''),2200)
    return ()=>clearTimeout(t)
  },[toast])
  return (
    <section className="section">
      <div className="container mx-auto px-4 grid md:grid-cols-2 gap-6 items-stretch">
        <div className="card">
          <h3 className="font-bold text-xl">{t('contact.title')}</h3>
          <p className="text-muted">{t('contact.subtitle')}</p>
          <form onSubmit={(e)=>{e.preventDefault(); setToast(t('contact.toast'))}} className="mt-4 space-y-3">
            <div className="grid sm:grid-cols-2 gap-3">
              <input className="w-full px-3 py-2 border border-blue-100 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary/30" placeholder={t('contact.name')} required />
              <input type="email" className="w-full px-3 py-2 border border-blue-100 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary/30" placeholder={t('contact.email')} required />
            </div>
            <textarea rows="4" className="w-full px-3 py-2 border border-blue-100 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary/30" placeholder={t('contact.message')}></textarea>
            <button className="btn btn-primary" type="submit">{t('contact.send')}</button>
          </form>
        </div>
        <div className="flex flex-col justify-between">
          <ul className="space-y-2">
            <li><strong>{t('contact.emailLabel')} :</strong> locapiol2025@gmail.com</li>
            <li><strong>{t('contact.phoneLabel')} :</strong> +49 176 47138157</li>
            <li><strong>{t('contact.addressLabel')} :</strong> Yaounde (CM) · Worms (DE)</li>
          </ul>
          <div className="grid grid-cols-2 gap-3 mt-4">
            <div className="card text-center font-bold">{t('contact.cm')}</div>
            <div className="card text-center font-bold">{t('contact.de')}</div>
          </div>
        </div>
      </div>
      <div className={"toast " + (toast ? "show" : "")} role="status" aria-live="polite">{toast}</div>
    </section>
  )
}
